import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Paper, Typography, Box, CircularProgress } from "@mui/material";
import { UserForm } from "../components/UserForm";
import { useFindUser } from "../../../../../api/bpm/endpoints";
import { useAuth } from "../../../../../auth";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/__auth/admin/users/$userId/")({
  component: ViewUserPage,
  staticData: {
    title: "routes.viewUser",
  },
});

function ViewUserPage() {
  const { t } = useTranslation();
  const { userId } = Route.useParams();
  const navigate = useNavigate();
  const { user: authUser } = useAuth();
  const tenant = authUser?.tenant || "default-domain";

  const { data: userDataRaw, isLoading } = useFindUser(tenant, userId);
  const userData = (userDataRaw as any)?.data || userDataRaw;

  if (isLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", p: 5 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" fontWeight={600} gutterBottom>
        {t("admin.users.viewTitle")}
      </Typography>
      <Paper sx={{ p: 3, mt: 3 }}>
        <UserForm
          initialData={userData}
          onSubmit={async () => {}}
          onCancel={() =>
            navigate({ to: "/admin/users", search: { page: 1, size: 10 } })
          }
          isView
        />
      </Paper>
    </Box>
  );
}
